import { createNotImplementedMethod } from '../utils';
var NotImplementedFiltersRepository = /** @class */ (function () {
    function NotImplementedFiltersRepository() {
        this.getCategories = createNotImplementedMethod();
        this.getFromWorld = createNotImplementedMethod();
    }
    return NotImplementedFiltersRepository;
}());
export { NotImplementedFiltersRepository };
